import { render, staticRenderFns } from "./SituacaoCirculo.vue?vue&type=template&id=1c6d1c13&scoped=true&"
import script from "./SituacaoCirculo.vue?vue&type=script&lang=js&"
export * from "./SituacaoCirculo.vue?vue&type=script&lang=js&"
import style0 from "./SituacaoCirculo.vue?vue&type=style&index=0&id=1c6d1c13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6d1c13",
  null
  
)

export default component.exports